import { useQueryClient } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import {
  DASHBOARD_ROUTE,
  QUESTIONAIRE_ROUTE,
  SIGNIN_ROUTE,
} from 'constants/routes';
import { removeUser } from 'store/slices/auth';
import { useAppDispatch } from './useRedux';

export const useLogout = () => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const router = useRouter();

  const logout = useCallback(() => {
    dispatch(removeUser());
    queryClient.removeQueries();
    if (
      router.pathname.includes(QUESTIONAIRE_ROUTE) ||
      router.pathname.includes(DASHBOARD_ROUTE)
    ) {
      router.replace(SIGNIN_ROUTE);
    }
  }, [dispatch, queryClient, router]);

  return {
    logout,
  };
};
